'use strict'

function initializeTabNavigation() {
  $(document).ready(function () {
    const tabItem = $('.tab-navigation__list ul li span')

    tabItem.on('click', function (e) {
      e.preventDefault()
      const $this = $(this)
      const tabIndicator = $this.attr('data-content')
      const tabNavigation = $('.tab-navigation__list')
      const tabContainer = $('#' + tabIndicator)

      $('.tab-navigation__list ul li span').removeClass('active')
      $this.addClass('active')

      $('.tab-navigation__container').removeClass('visible')
      tabContainer.addClass('visible')
      const leftOffset = $this.offset().left - tabNavigation.offset().left + tabNavigation.scrollLeft();
      tabNavigation.animate({ scrollLeft: leftOffset - 60 });

      // Rebuild sliders - this is necessary because slick slider sets the width of the slider
      // according to what's visible on the screen. If the slider is hidden, it will have a width of 0.
      reloadSlider()
    })
  })

  /**
   * Reload slider
   * This is essentially just a copy of the slider initialization code from the slider.js file.
   * Because slick('unload') is called, the sliders are destroyed and need to be rebuild.
   */
  function reloadSlider() {
    const $gridSlider = $(".slider--case .slider__element");
    const $addArrows = true;
    $gridSlider.each(function (i, el) {
      const $this = $(el);
      $this.slick("unslick");
      let contWidth = 0;
      if (contWidth < $(window).width()) {
        contWidth =
          $(window).width() * 0.5 + $(".container-fluid").outerWidth() / 2;
      } else {
        contWidth = $(".container-fluid").outerWidth();
      }
      const sliderElement = $this.find(".grid__item");
      const noOfSlides = sliderElement.length;
      // Add navigation
      if ($addArrows) {
        const $parentContainer = $this
          .parents("section")
          .find(".slider-container");
        if (!$parentContainer.children(".slider__arrow-wrap").length) {
          $parentContainer.append(
            '<div class="slider__arrow-wrap hidden visible-sm"></div>'
          );
        }
      }
      let responsive = [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 992,
          settings: "unslick",
        },
      ];
      let appendArrowElement = $this
        .closest("section")
        .find(".slider__arrow-wrap");
      if (!$this.hasClass("slick-initialized")) {
        $this.slick({
          slidesToShow: noOfSlides > 1 ? 1.3 : 1,
          slidesToScroll: 1,
          infinite: false,
          arrows: $addArrows,
          mobileFirst: true,
          prevArrow:
            '<button type="button" class="slick-prev"><i class="material-icons-outlined">chevron_left</i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><i class="material-icons-outlined">chevron_right</i></button>',
          appendArrows: appendArrowElement,
          dots: false,
          touchThreshold: 10,
          focusOnSelect: true,
          swipeToSlide: true,
          responsive: responsive,
        });
      }
    });
  }
}

export default initializeTabNavigation
